import { AgmCoreModule } from '@agm/core';
import { HttpClientModule } from '@angular/common/http'
import { NgModule } from '@angular/core';
import { MatTabsModule } from '@angular/material';
import { MatDialogModule } from '@angular/material/dialog';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { BsDropdownModule } from 'ngx-bootstrap/dropdown'
import { TooltipModule } from 'ngx-bootstrap/tooltip'
import { CKEditorModule } from 'ngx-ckeditor'
import { LoaderModule } from './loader/loader.module'

import { EqualValidator } from './_directives/equal-validator.directive'
import { AlertComponent } from './_directives/index'
import { AlertService } from './_services/index'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component'
import { AuthGuard } from './guard'
import { BrandManagementComponent } from './home/brand-management/brand-management.component'
import { ProductManagementComponent } from './home/product-management/product-management.component'
import { RecipesManagementComponent } from './home/recipes-management/recipes-management.component'
import { UserManagementComponent } from './home/user-management/user-management.component'
import { LoginComponent } from './login/login.component'
import { NavigationComponent } from './navigation/navigation.component'
import { PipeModule } from './pipemodule/pipe.module'
import { ChangePasswordComponent } from './profile-management/change-password/change-password.component'
import { EditProfileComponent } from './profile-management/edit-profile/edit-profile.component'
import { ProfileManagementComponent } from './profile-management/profile-management.component'
import { ProfileComponent } from './profile-management/profile/profile.component'
import { Ng2DeviceDetectorModule } from 'ng2-device-detector';
import { ChartsModule, ThemeService } from 'ng2-charts';


import { ResetPasswordComponent } from './reset-password/reset-password.component'
import { ColorPickerModule } from 'ngx-color-picker'
import { NotFoundComponent } from './not-found/not-found.component';
import { PermissionComponent } from './permission/permission.component';
import { AppService } from './app.service'
import { BrandDeleteComponent } from './home/brand-management/brand-delete/brand-delete.component';

@NgModule({
  declarations: [
    AlertComponent,
    AppComponent,
    LoginComponent,
    NavigationComponent,
    ResetPasswordComponent,
    ForgotPasswordComponent,
    ProductManagementComponent,
    BrandManagementComponent,
    UserManagementComponent,
    RecipesManagementComponent,
    ChangePasswordComponent,
    ProfileManagementComponent,
    ProfileComponent,
    EditProfileComponent,
    EqualValidator,
    NotFoundComponent,
    PermissionComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatTabsModule,
    MatDialogModule,
    ChartsModule,
    MatTooltipModule,
    TooltipModule.forRoot(),
    BsDropdownModule.forRoot({}),
    CKEditorModule,
    HttpClientModule,
    PipeModule,
    MatProgressSpinnerModule,
    LoaderModule,
    ColorPickerModule,
    Ng2DeviceDetectorModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyANp1gacZewUy0SjwF2FOoa0lLnzkCyBeY',
      libraries: ['places']
    })
  ],
  entryComponents: [ChangePasswordComponent, EditProfileComponent],
  providers: [AlertService, AppService, AuthGuard ,ThemeService],
  bootstrap: [AppComponent ],
})
export class AppModule {}
